import { render, staticRenderFns } from "./NewTeacher.vue?vue&type=template&id=e668401c&"
import script from "./NewTeacher.vue?vue&type=script&lang=js&"
export * from "./NewTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsDivider,VBreadcrumbsItem})
